type PriceWithLeadTime = {
  leadTimeWeeks?: number | null;
};

/**
 * Lead time lives on each quote price (quantity break), but several consumers
 * need a single value for the whole line: Visual stores one lead time per quote
 * line, and quote documents that do not break lead time out per quantity quote
 * one figure.
 *
 * Those consumers take the smallest across the line's prices. Prices without a
 * lead time are ignored; returns null when no price has one.
 *
 * @note Taking the smallest advertises the *best* case — the lead time for the
 * smallest quantity — to anyone ordering a larger break. This is the one place
 * the per-price model collapses back to a single promise, so it lives here
 * rather than being restated at each call site.
 *
 * @note Smallest is CAP's requirement, not a universal rule. A site quoting a
 * delivery guarantee would want the largest instead, so which end of the range
 * collapses here belongs in site config; until then it is hardcoded.
 */
export function getSmallestLeadTime(
  prices: PriceWithLeadTime[],
): number | null {
  const leadTimes = prices
    .map((price) => price.leadTimeWeeks)
    .filter((leadTime): leadTime is number => leadTime != null);

  return leadTimes.length ? Math.min(...leadTimes) : null;
}
